import React from "react";
import { TitleActionGroupProps } from "./Title.types";
import { ActionGroup as StyledActionGroup } from "./ActionGroup.styles";

/**
 * Visually groups actions within the main Actions section. This is required if
 * the responsive layout requires grouping for different breakpoints.
 */
export const ActionGroup = ({ children, className }: TitleActionGroupProps) => (
  <StyledActionGroup className={className}>{children}</StyledActionGroup>
);
